module.exports = "mat-card{\n    margin-bottom:20px;\n}\n\n/* .example-card {\n    min-width: 400px;\n  } */"


//////////////////
// WEBPACK FOOTER
// ./src/app/publicaciones/mispublicaciones/mispublicaciones.component.css
// module id = ./src/app/publicaciones/mispublicaciones/mispublicaciones.component.css
// module chunks = main